import React from 'react'

import './roomsunavailable.css'

const RoomsUnavailable = () => {
	return (
		<div className="roomsunavailable">
			<p className="not-available">SALAS NO DISPONIBLES</p>
			<p>No hay salas disponibles para el día y hora seleccionados, puedes probar en otro día y/u hora.</p>
		</div>
	)
}

export default RoomsUnavailable